<template>
	<form 
		class="searchbar flex flex-row justify-start items-start w-full border-b py-2 lg:py-1"
		:class="`border-${ borderColor }`"
		@submit.prevent="submitSearch"
	>
		<input v-model="query" placeholder="Search...">
		<UiButton
			type="icon"
			name="Magnify"
			theme="transparent"
			class="ml-2"
		/>
	</form>
</template>

<script>
import globalMixins from '@/mixins/global-mixins'

import UiButton from '@/components/ui/Button'

export default {
	name: 'SearchBar',
	components: {
		UiButton,
	},
	mixins: [
		globalMixins
	],
	props: {
		borderColor: {
			type: String,
			default: 'black'
		}
	},
	data() {
		return {
			query: ''
		}
	},
	methods: {
		submitSearch() {
			const url = this.baseUrl + 'search?q=' + this.query
			this.redirect(url)
			console.log('submitSearch', this.query)
			console.log('analytics')
			this.query = ''
		}
	}
}
</script>

<style scoped>
.searchbar > input::placeholder { color: var(--tertiary-textcolor); }
</style>